function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.0982 12C13.8348 12 12 13.8348 12 16.0982C12 18.3616 13.8348 20.1964 16.0982 20.1964C16.91 20.1964 17.6666 19.9604 18.3032 19.5533L19.491 20.7411C19.8362 21.0863 20.3959 21.0863 20.7411 20.7411C21.0863 20.3959 21.0863 19.8362 20.7411 19.491L19.5533 18.3032C19.9604 17.6666 20.1964 16.91 20.1964 16.0982C20.1964 13.8348 18.3616 12 16.0982 12ZM17.7955 17.6951C18.188 17.278 18.4286 16.7162 18.4286 16.0982C18.4286 14.8112 17.3852 13.7679 16.0982 13.7679C14.8112 13.7679 13.7679 14.8112 13.7679 16.0982C13.7679 17.3852 14.8112 18.4286 16.0982 18.4286C16.7162 18.4286 17.278 18.188 17.6951 17.7955C17.7103 17.7776 17.7264 17.7602 17.7433 17.7433C17.7602 17.7264 17.7776 17.7103 17.7955 17.6951Z",
  fill: "#555770"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 4.7C2 3.20883 3.20883 2 4.7 2H17.3C18.7912 2 20 3.20883 20 4.7V11C20 11.4971 19.5971 11.9 19.1 11.9C18.6029 11.9 18.2 11.4971 18.2 11V4.7C18.2 4.20294 17.7971 3.8 17.3 3.8H4.7C4.20294 3.8 3.8 4.20294 3.8 4.7V17.3C3.8 17.7971 4.20294 18.2 4.7 18.2H10.19C10.6871 18.2 11.09 18.6029 11.09 19.1C11.09 19.5971 10.6871 20 10.19 20H4.7C3.20883 20 2 18.7912 2 17.3V4.7Z",
  fill: "#555770"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 7.5C5 7.22386 5.22386 7 5.5 7H16.5C16.7761 7 17 7.22386 17 7.5C17 7.77614 16.7761 8 16.5 8H5.5C5.22386 8 5 7.77614 5 7.5Z",
  fill: "#555770"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.88889 10.5C4.88889 10.2239 5.11274 10 5.38889 10H14.3889C14.665 10 14.8889 10.2239 14.8889 10.5C14.8889 10.7761 14.665 11 14.3889 11H5.38889C5.11274 11 4.88889 10.7761 4.88889 10.5Z",
  fill: "#555770"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 13.5C5 13.2239 5.22386 13 5.5 13H10.5C10.7761 13 11 13.2239 11 13.5C11 13.7761 10.7761 14 10.5 14H5.5C5.22386 14 5 13.7761 5 13.5Z",
  fill: "#555770"
});

function SvgPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.7ac23a69.svg";
export { ForwardRef as ReactComponent };